module.exports = __webpack_public_path__ + "img/image_online08@2x.67007d9b.png";